import { t } from 'ember-intl';
import type { TOC } from '@ember/component/template-only';
import tw from '../helpers/tw';
import { itemTypeTrKey } from '../utils/tr-keys';

const TYPE_CLASSES: Record<string, string> = {
  movie: 'bg-item-movie text-item-movie-text',
  tv_show: 'bg-item-tv-show text-item-tv-show-text',
  book: 'bg-item-book text-item-book-text',
  music: 'bg-item-music text-item-music-text',
  podcast: 'bg-item-podcast text-item-podcast-text',
  recipe: 'bg-item-recipe text-item-recipe-text',
  video_game: 'bg-item-video-game text-item-video-game-text',
  place: 'bg-item-place text-item-place-text',
  product: 'bg-item-product text-item-product-text',
  person: 'bg-item-person text-item-person-text',
  brand: 'bg-item-brand text-item-brand-text',
  event: 'bg-item-event text-item-event-text',
  unknown: 'bg-item-unknown text-item-unknown-text',
};

interface TypeBadgeSignature {
  Args: {
    type: string | null | undefined;
  };
  Element: HTMLSpanElement;
}

function typeClass(type: string | null | undefined): string {
  if (!type) return '';

  return TYPE_CLASSES[type] ?? '';
}

const TypeBadgeTemplate: TOC<TypeBadgeSignature> = <template>
  {{#if @type}}
    <span class={{tw "badge badge-sm" (typeClass @type)}} ...attributes>
      {{t (itemTypeTrKey @type) default=@type}}
    </span>
  {{/if}}
</template>;

export default TypeBadgeTemplate;
